import React, {Component} from 'react';
import Avatar from 'material-ui/Avatar';
import AvatarIcon from 'material-ui/svg-icons/action/account-circle';

import { connect } from '../../utils';

class AvatarView extends Component{

  renderLink(url,size, href, target) {
    return(
      <a href={href.url} target={target}>
        <Avatar
          icon={<AvatarIcon />}
          color="#FFFFFF"
          src={url}
          backgroundColor="#CFD8DC"
          size={size}
        />
        </a>
    )
  }
  renderNotLink(url,size) {
    return(
      <Avatar
        icon={<AvatarIcon />}
        color="#FFFFFF"
        src={url}
        backgroundColor="#CFD8DC"
        size={size}
      />
    )
  }
  render(){
    const {id, layoutState} = this.props;
    const {containerPadding, url,size, align, href} = layoutState.getItemJS(id).props.values;
    const target = (href && href.target && href.target ==="_blank") ? "_blank": "";
    const child = (href && href.url !== "") ? this.renderLink(url,size, href, target) : this.renderNotLink(url, size);
    return(
      <div style={{
        boxSizing: 'border-box',
        position: 'relative',
        height: '100%',
        display: 'flex',
        padding:containerPadding,
        flex:1,
        justifyContent: align
      }}>
        {child}
      </div>
    )
  }
}
export default connect('layoutState')(AvatarView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/AvatarView.js